import { render, staticRenderFns } from "./RelayExceptionalClosures.vue?vue&type=template&id=46340131&"
import script from "./RelayExceptionalClosures.vue?vue&type=script&lang=ts&"
export * from "./RelayExceptionalClosures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports